import React from "react";
import { Link } from "react-scroll";
import Pagetitle from "../elements/Pagetitle";
import Service from "../elements/Service";

const servicesData = [
  {
    icon: "images/service-1.svg",
    title: "Front-End Developer",
    content:
      "HTML5, CSS4, Javascript, Typescript, React, React Redux, Angular, Jquery, Bootstrap, Material Design UI, Razor Pages, Charts, Figma, Notion.so and Adobe XD",
    color: "#2F6F73",
  },
  {
    icon: "images/service-2.svg",
    title: "Back-End Developer",
    content:
      "C#, .Net, PHP, SQL, NodeJs, Wordpress, SignalR, AspNetBoilerplate, Microservices, API's, Pimcore, Ocelot, HabbitMQ, Background Jobs and OAuth",
    color: "#C0563D",
  },
  {
    icon: "images/service-2.svg",
    title: "DevOps",
    content:
      "Azure, Amazon AWS, Vercel, Github, Bitbucket, Jenkins, NodeJs, Jira, Apache, IIS, Nginx, NextJs, Continuous integration (CI) and Continuous Delivery (CD)",
    color: "#E0A838",
  },
];

function Services() {
  return (
    <section id="services">
      <div className="container">
        <Pagetitle title="Areas" />
        <div className="row fix-spacing">
          {servicesData.map((service, key) => (
            <div className="col-md-4" key={key}>
              <Service service={service} />
            </div>
          ))}
        </div>
        <div className="mt-5 text-center">
          <p className="mb-0">
            Looking for a software engineer?{" "}
            <Link
              className="colorpink pointer"
              to="section-contact"
              spy={true}
              smooth={true}
              duration={500}
            >
              Click here
            </Link>{" "}
            to contact me! 👋
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;
